import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import IncompleteUsersService from "@/services/api/incompleteUsers";
import type {
  IncompleteUsersResponse,
  SortOrder,
  IncompleteUserSortBy,
} from "@/services/api/incompleteUsers";

export const incompleteUsersKeys = {
  all: ["incomplete-users"] as const,
  list: (page: number, limit: number, sortOrder: SortOrder, sortBy?: IncompleteUserSortBy, search?: string | null) =>
    [...incompleteUsersKeys.all, { page, limit, sortOrder, sortBy, search: search ?? "" }] as const,
};

interface UseIncompleteUsersParams {
  page: number;
  limit: number;
  sortOrder?: SortOrder;
  sortBy?: IncompleteUserSortBy;
  search?: string | null;
  enabled?: boolean;
}

export function useIncompleteUsers({
  page,
  limit,
  sortOrder = "desc",
  sortBy,
  search,
  enabled = true,
}: UseIncompleteUsersParams) {
  return useQuery<IncompleteUsersResponse>({
    queryKey: incompleteUsersKeys.list(page, limit, sortOrder, sortBy, search),
    queryFn: async () => {
      try {
        return await IncompleteUsersService.getIncompleteUsers({
          limit,
          offset: (page - 1) * limit,
          search,
          sortBy,
          sortOrder,
        });
      } catch (error: any) {
        toast.error(error?.message || "Failed to fetch incomplete users");
        throw error;
      }
    },
    placeholderData: (previousData) => previousData,
    enabled,
  });
}
